/* tslint:disable */
/* eslint-disable */
/**
 * ReD Admin API Spec
 * ReD中途企業向けサイト用API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redesigner.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetBanners200Response,
  SaveSearchCondition200Response,
} from '../models/index';
import {
    GetBanners200ResponseFromJSON,
    GetBanners200ResponseToJSON,
    SaveSearchCondition200ResponseFromJSON,
    SaveSearchCondition200ResponseToJSON,
} from '../models/index';

export interface GetBannersRequest {
    displayLocation?: number;
}

/**
 * 
 */
export class BannerApi extends runtime.BaseAPI {

    /**
     * バナー情報を取得します。
     * バナー取得
     */
    async getBannersRaw(requestParameters: GetBannersRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBanners200Response>> {
        const queryParameters: any = {};

        if (requestParameters.displayLocation !== undefined) {
            queryParameters['display_location'] = requestParameters.displayLocation;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-ADMIN-Token"] = await this.configuration.apiKey("X-ADMIN-Token"); // X-ADMIN-Token authentication
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-API-Token"] = await this.configuration.apiKey("X-API-Token"); // X-API-Token authentication
        }

        const response = await this.request({
            path: `/enterprise/banners`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBanners200ResponseFromJSON(jsonValue));
    }

    /**
     * バナー情報を取得します。
     * バナー取得
     */
    async getBanners(requestParameters: GetBannersRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBanners200Response> {
        const response = await this.getBannersRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
